import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import SignupPage from "./pages/signup";
import LoginPage from "./pages/login";
import Dashboard from "./pages/home";
import OTPPage from "./pages/otp";
import ForgotPassword from "./pages/forgot_password";
import ResetPassword from "./pages/reset_password";
import SearchQuestions from "./pages/search_questions";
import SelectQuiz from "./pages/select_quiz";
import ResultPage from "./pages/result_page";
import NotFound from "./pages/404";
import StudentProfilePage from "./pages/profile";
import { QuizProvider } from "./utils/api/Redux/QuizContext";
import ExamHistory from "./pages/exam_history";
import OTPResetPage from "./pages/otpRestPass";
import { SessionExpirationPopup } from "./components/sessionExpiredPopup";
import SubscriptionModal from "./components/subscriptionModal";
import OnboardingPage from "./pages/onboarding";
import { GoogleOAuthProvider } from "@react-oauth/google";
import UpdateAcademicInfoPage from "./pages/acdemic update";
import SingleSubjectQuiz from "./pages/take_exam";
import NotificationPage from "./pages/notifications";
import SubjectAnalysis from "./pages/perfomance";
import Leaderboard from "./pages/leader board";
import ExamPerformance from "./pages/exam_performance";
import ParentDashboard from "./pages/parents dashboard";
import IndividualChildStatsPage from "./pages/individual kid stats";
import ExamPerformanceIndividual from "./pages/exam_performance parent";
import StudentSubjectAnalysisIndividual from "./pages/perfomance indivdual";
import SelectQuizIndividual from "./pages/select_quiz  individual";
import LeaderboardIndividual from "./pages/leader board  individual";
import HomePage from "./pages/website/home";
import FeaturesPage from "./pages/website/features";
import ContactPage from "./pages/website/contact-us";
import AboutPage from "./pages/website/about";
import PricingAndSubjectsPage from "./pages/website/pricing";
import TestimonialsPage from "./pages/website/testimonials";
import WebsiteLayout from "./WebsiteLayout";
import ScrollToTop from "./ScrollToTop";
import GroupExamPage from "./pages/group_pages";
import GroupExamsPage from "./pages/group details";
import GroupExamDashboard from "./pages/group_pages";
import TakeSession from "./pages/take-session";
import ResultPageExam from "./pages/result page exam";
import ResultActivityPage from "./pages/result_activity";
import PublicGroupInvitePage from "./pages/group-invite";
import { jwtDecode } from "jwt-decode";
import { API_BASE_URL } from "./config/apiConfig";
import { Toaster } from "sonner";
import TermsOfService from "./pages/website/terms of service";
import Policies from "./pages/website/privacy-policy";
import PaymentSuccess from "./components/PaymentSuccess";
import FreeLoginPage from "./pages/free login";
import FreeUsersOnboardingPage from "./pages/onboarding free users";
import FreeDashboard from "./pages/free home";
import TakeSessionFree from "./pages/take-session free";
import SingleSubjectQuizFree from "./pages/take_exam_free";
import ResultPageExamFree from "./pages/result page exam free";
import SelectQuizFree from "./pages/select_quiz free";
import SubscriptionGate from "./components/SubscriptionGate ";
import ExamPageFree from "./pages/exam _page free";
import ExamPage from "./pages/exam _page";
import ResultCheckPageFree from "./pages/free result page";
import TakeJAMBOrWAECSession from "./pages/take-session Waec";
import ChooseExamPage from "./pages/choose exam";
import WaecOrJambExam from "./pages/waec or jamb exam";
import ChooseExamPageFree from "./pages/choose exam free";
import TakeJAMBOrWAECSessionFree from "./pages/take-session Waec free";
import WaecOrJambExamFree from "./pages/waec or jamb exam free";
import ResultPageExamWAEC from "./pages/result page exam waec";
import TeacherDashboard from "./pages/teacher dashboard";
import JoinTeacherPage from "./pages/join teacher";
import JoinParentPage from "./pages/join-parent";
import WebinarRegistrationPage from "./pages/webinar";
import TeacherLessonManager from "./pages/teacher_lessons";
import LessonBuilder from "./pages/teacher_lesson_build";
import TeacherQuestionBuilder from "./pages/teacher_questions";
import MyLessons from "./pages/lessons";
import LessonDetail from "./pages/lesson_detail";
import StudyPlan from "./pages/study_plan";
import Readiness from "./pages/readiness";
import Predictions from "./pages/predictions";
import AssistantPage from "./pages/assistant";
import MockExamGenerator from "./pages/mock_exam";
import Marketplace from "./pages/marketplace";
import TeacherMarketplace from "./pages/teacher_marketplace";
import MarketplacePaymentSuccess from "./pages/marketplace_payment_success";
import LiveSessions from "./pages/live_sessions";
import TeacherLiveSessions from "./pages/teacher_live_sessions";
import Achievements from "./pages/achievements";
import Guidance from "./pages/guidance";
import EssayPractice from "./pages/essay";



function AppContent() {

  const location = useLocation();
  const token = localStorage.getItem("token");
  const [subscribed, setSubscribed] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setSubscribed(true); // assume subscribed or hide modal until login
      return;
    }
    const fetchSubscriptionStatus = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/sub/single`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error("Failed to fetch subscription");
        const data = await res.json();

        const today = new Date();

        // Check if any subscription is active AND not expired
        const isSubscribed = data?.subscriptions?.some((sub) => {
          const expiry = new Date(sub.expiry_date);
          return sub.status === "Active" && expiry >= today;
        });

        setSubscribed(isSubscribed);
      } catch (err) {
        console.error(err);
        setSubscribed(false);
      }
    };


    fetchSubscriptionStatus();
  }, [token]); // 👈 runs again whenever token changes




  // Pages where m-11 should NOT be applied
  const excludedPaths = [
    "/login",
    "/register",
    "/",
    "/forgot-password",
    "/otp",
    "/onboarding",
    "/update-academics",
    "/reset-password",
    "/reset-otp",
    "/signup",
    "/features",
    "/contact-us",
    "/pricing",
    "/about",
    "/subjects",
    "/privacy-policy",
    "/terms-of-service",
    "/testimonials",
    "/group-invite",
    "/group-invite/accept",
    "/group-invite/reject",
    "/free-login",
    "/free-onboarding",
    "/free-dashboard",
    "/free-take",
    "/take-exam-free",
    "/exam-free",
    "/result-exam-free",
    "/exam-history-free",
    "/free-result",
    "/child-stats",
    "/student-stats",
    "/exam-history-individual",
    "/teacher-dashboard",
    "/parent-dashboard",
    "/performance-insights-individual",
    "/leaderboard-individual",
    "/exam-performance-individual",
    "/join-teacher",
    "/join-parent",
    "/webinar"

  ];

  // Updated check for excluded paths
  const isExcluded = excludedPaths.some(
    (path) =>
      path === location.pathname || // exact match
      (path === "/free-take" && location.pathname.startsWith("/free-take/")) ||
      (path === "/free-result" && location.pathname.startsWith("/free-result/")) 
      // dynamic route
  );
  
  // -------------------------------
  // ⭐ VISIT TRACKING ADDED HERE ⭐
  // -------------------------------
  useEffect(() => {
    const trackVisit = async () => {
      try {
        await fetch(`${API_BASE_URL}/api/visits`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ page: location.pathname }),
        });
      } catch (error) {
        console.error("Visit tracking failed:", error);
      }
    };

    trackVisit();
  }, [location.pathname]);

  // if (!subscribed && !isExcluded) {
  //   return <SubscriptionGate />;
  // }  




  return (
    <GoogleOAuthProvider clientId="50799059274-v8amq158okvehhen95fhu1quogvbrif4.apps.googleusercontent.com">
      <ScrollToTop />
      <Toaster position="top-right" richColors />
      <div className="font-montserrat">
        {/* Render subscription modal only if not excluded, not subscribed,
            and NOT a teacher or parent (they never need a subscription) */}
        {!isExcluded && !subscribed && !["teacher", "parent"].includes(localStorage.getItem("accountType")) && (
          <div className="m-11">
            <SubscriptionModal />
          </div>
        )}

        <SessionExpirationPopup />

        {/* {!isExcluded && !subscribed && <SubscriptionGate />}<SubscriptionGate /> */}
        <Routes>
          <Route element={<WebsiteLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/contact-us" element={<ContactPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/pricing" element={<PricingAndSubjectsPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />

          </Route>
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/free-login" element={<FreeLoginPage />} />
          <Route path="/free-onboarding" element={<FreeUsersOnboardingPage />} />
          <Route path="/free-dashboard" element={<FreeDashboard />} />
          <Route path="/free-take/:mode" element={<TakeSessionFree />} />
          <Route path="/take-exam-free" element={<SingleSubjectQuizFree />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/parent-dashboard" element={<ParentDashboard />} />
          <Route path="/teacher-dashboard" element={<TeacherDashboard />} />
          <Route path="/join-teacher" element={<JoinTeacherPage />} />
          <Route path="/join-parent" element={<JoinParentPage />} />
          <Route path="/webinar" element={<WebinarRegistrationPage />} />
          <Route path="/teacher/lessons" element={<TeacherLessonManager />} />
          <Route path="/teacher/lessons/:id/build" element={<LessonBuilder />} />
          <Route path="/teacher/questions" element={<TeacherQuestionBuilder />} />
          <Route path="/lessons" element={<MyLessons />} />
          <Route path="/lessons/:id" element={<LessonDetail />} />
          <Route path="/study-plan" element={<StudyPlan />} />
          <Route path="/readiness" element={<Readiness />} />
          <Route path="/predictions" element={<Predictions />} />
          <Route path="/assistant" element={<AssistantPage />} />
          <Route path="/mock-exam" element={<MockExamGenerator />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/teacher/marketplace" element={<TeacherMarketplace />} />
          <Route path="/marketplace/payment-success" element={<MarketplacePaymentSuccess />} />
          <Route path="/live" element={<LiveSessions />} />
          <Route path="/teacher/live" element={<TeacherLiveSessions />} />
          <Route path="/achievements" element={<Achievements />} />
          <Route path="/guidance" element={<Guidance />} />
          <Route path="/essay" element={<EssayPractice />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/otp" element={<OTPPage />} />
          <Route path="/reset-otp" element={<OTPResetPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/search-questions" element={<SearchQuestions />} />
          {/* <Route path="/result-checker" element={<SelectQuiz />} /> */}
          <Route path="/result" element={<ResultPage />} />
          <Route path="/choose-exam" element={<ChooseExamPage />} />
          <Route path="/choose-exam-free" element={<ChooseExamPageFree />} />
          <Route path="/take/:mode" element={<TakeSession />} />
          <Route path="/take-promotional/:examType" element={<TakeJAMBOrWAECSession />} />
          <Route path="/take-promotional-free/:examType" element={<TakeJAMBOrWAECSessionFree />} />
          <Route path="/groups" element={<GroupExamDashboard />} />
          <Route path="/groups/:id" element={<GroupExamsPage />} />
          <Route path="/profile" element={<StudentProfilePage />} />
          <Route path="/take-exam" element={<SingleSubjectQuiz />} />
          <Route path="/performance-insights" element={<SubjectAnalysis />} />
          <Route path="/performance-insights-individual" element={<StudentSubjectAnalysisIndividual />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/leaderboard-individual" element={<LeaderboardIndividual />} />
          <Route path="/free-result" element={<ResultCheckPageFree />} />
          <Route path="/exam" element={<ExamPage />} />
          <Route path="/exam-promo" element={<WaecOrJambExam />} />
          <Route path="/exam-promo-free" element={<WaecOrJambExamFree />} />
          <Route path="/exam-free" element={<ExamPageFree />} />
          <Route path="/notification" element={<NotificationPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/update-academics" element={<UpdateAcademicInfoPage />} />
          <Route path="/result-exam" element={<ResultPageExam />} />
          <Route path="/activity-result" element={<ResultActivityPage />} />
          <Route path="/result-exam-free" element={<ResultPageExamFree />} />
          <Route path="/result-exam-free-session" element={<ResultPageExamWAEC />} />
          <Route path="/exam-history" element={<SelectQuiz />} />
          <Route path="/exam-history-free" element={<SelectQuizFree />} />

          <Route path="/exam-history-individual" element={<SelectQuizIndividual />} />
          <Route path="/group-invite/accept/:groupId/:groupName" element={<PublicGroupInvitePage />} />
          <Route path="/group-invite/reject/:groupId/:groupName" element={<PublicGroupInvitePage />} />
          <Route path="/exam-performance" element={<ExamPerformance />} />
          <Route path="/exam-performance-individual" element={<ExamPerformanceIndividual />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/child-stats" element={<IndividualChildStatsPage />} />
          <Route path="/student-stats" element={<IndividualChildStatsPage />} />
          <Route path="/privacy-policy" element={<Policies />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />


          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </GoogleOAuthProvider>
  );
}



function App() {
  return (
    <QuizProvider>
      <Router>
        <AppContent />
      </Router>
    </QuizProvider>
  );
}

export default App;
